<template>
  <b-container class="p-3" fluid>
    <portal to="project-action-bar">
      <template v-if="$auth.check('coordinator') && project.status === 'Draft'">
        <b-button :to="{ name: 'projects.show.proposal.budget.edit', params: $route.params }" variant="info"><font-awesome-icon icon="pencil-alt" />แก้ไขข้อมูล</b-button>
      </template>
    </portal>

    <loading-spinner v-if="isLoading" text="กำลังโหลด..." />
    <div v-else class="row">
      <div class="col-12">
        <show-proposal-budget-planning v-bind="project" />
      </div>
    </div>
  </b-container>
</template>

<script>
import ShowProposalBudgetPlanning from '@/components/project/ShowProposalBudgetPlanning'
import LoadingSpinner from '@/components/layouts/LoadingSpinner'

export default {
  components: {
    ShowProposalBudgetPlanning,
    LoadingSpinner
  },
  data: () => ({
    isLoading: true
  }),
  computed: {
    project () { return this.$store.getters['project/getProject'](this.$route.params.id) }
  },
  created () {
    this.$store.dispatch('project/loadBudget', this.$route.params.id).then(() => {
      this.isLoading = false
    })
  }
}
</script>
